import React from "react";
import { Tabs, Tab, Tooltip, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function getShortTitle(title = "", isSmall) {
  const limit = isSmall ? 14 : 22; // μικρό όριο σε κινητό
  if (title.length <= limit) return title;
  return title.slice(0, limit - 1) + "…";
}

function TrafficBar({ data = [], selectedData, setSelectedData }) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  // limit items to avoid UI overflow
  const visible = data.slice(0, 20);
  const visibleIds = visible.map((item) => item.id);

  const currentValue = visibleIds.includes(selectedData?.id)
    ? selectedData.id
    : visibleIds[0] ?? null;

  const handleChange = (_, newValue) => {
    const found = data.find((item) => item.id === newValue);
    if (found) setSelectedData(found);
  };

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Tabs
        value={currentValue}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="traffic bar tabs"
        sx={{
          width: "100%",
          "& .MuiTabs-scrollButtons": { display: "flex" },
        }}
      >
        {visible.map((item) => (
          <Tab
            key={item.id}
            value={item.id}
            label={
              <Tooltip title={item.title} arrow>
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    maxWidth: "100%",
                  }}
                >
                  {getShortTitle(item.title, isSmall)}
                </span>
              </Tooltip>
            }
            sx={{
              textTransform: "none",
              minWidth: { xs: 80, sm: 100, md: 120 },
              maxWidth: { xs: 140, md: 200 },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
}

export default React.memo(TrafficBar);
